<form nz-form nz-row [formGroup]="authorizationsForm" class="ppl-p0">
    @if (!isConsumerSelected || mode==='edit'){
    @if(mode==='add') {
    <div class="row pb-3 mt-0" style="width: 100%">
        <h4 class="step-header">Step 1: Search Participant</h4>
    </div>

    }
    <div class="row pb-3 mt-0 ml-0" style="width: 100%; margin-left: 2px">
        @if(isAttrAvailable('consumerFirstName')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="consumerFirstName"
                    class="ppl-form-label">{{getAttributes('consumerFirstName').label}}
                    @if(getAttributes('consumerFirstName').mandatory === 'Y'){
                    <span>*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('consumerFirstName')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <input nz-input formControlName="consumerFirstName" id="consumerFirstName"
                            placeholder="{{getAttributes('consumerFirstName').placeholder}}"
                            [ngClass]="{'error': validationErrors['consumerFirstName'] }" />
                    </div>
                    @if (validationErrors['consumerFirstName']) {
                    <span class="pl-1 error-message">{{validationErrors['consumerFirstName']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }

        @if(isAttrAvailable('consumerLastName')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="consumerLastName"
                    class="ppl-form-label">{{getAttributes('consumerLastName').label}}
                    @if(getAttributes('consumerLastName').mandatory === 'Y'){
                    <span>*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('consumerLastName')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <input nz-input formControlName="consumerLastName" id="consumerLastName"
                            placeholder="{{getAttributes('consumerLastName').placeholder}}"
                            [ngClass]="{'error': validationErrors['consumerLastName'] }" />
                    </div>
                    @if (validationErrors['consumerLastName']) {
                    <span class="pl-1 error-message">{{validationErrors['consumerLastName']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }

        @if(isAttrAvailable('medicaid')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="medicaid"
                    class="ppl-form-label">{{getAttributes('medicaid').label}}
                    @if(getAttributes('medicaid').mandatory === 'Y'){
                    <span>*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('medicaid')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <input nz-input formControlName="medicaid" id="medicaid"
                            placeholder="{{getAttributes('medicaid').placeholder}}"
                            [ngClass]="{'error': validationErrors['medicaid'] }" />
                    </div>
                    @if (validationErrors['medicaid']) {
                    <span class="pl-1 error-message">{{validationErrors['medicaid']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }

        @if(isAttrAvailable('consumerPPLId')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="consumerPPLId"
                    class="ppl-form-label">{{getAttributes('consumerPPLId').label}}
                    @if(getAttributes('consumerPPLId').mandatory === 'Y'){
                    <span>*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('consumerPPLId')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <input nz-input formControlName="consumerPPLId" id="consumerPPLId"
                            placeholder="{{getAttributes('consumerPPLId').placeholder}}"
                            [ngClass]="{'error': validationErrors['consumerPPLId'] }" />
                    </div>
                    @if (validationErrors['consumerPPLId']) {
                    <span class="pl-1 error-message">{{validationErrors['consumerPPLId']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }
    </div>
    }
    @if(!isNewAuthSubmitted && isConsumerSelected) {
    <div class="row pb-3 mt-0" style="width: 100%">
        <h4 class="step-header">Step 3: Authorization Details</h4>
    </div>
    <div class="row pb-2 mt-0" style="width: 100%">
        <h5>Participant Info:</h5>
    </div>
    <div nz-row style="width: 100%; margin-left: 15px">
        <div nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="consumerFirstName" class="ppl-form-label">
                    {{getAttributes('consumerFirstName').label}}
                </nz-form-label>
                <nz-form-label [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    {{selectedConsumer.consumerFirstName}}
                </nz-form-label>
            </nz-row>

        </div>
        <div nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="consumerLastName" class="ppl-form-label">
                    {{getAttributes('consumerLastName').label}}
                </nz-form-label>
                <nz-form-label [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    {{selectedConsumer.consumerLastName}}
                </nz-form-label>
            </nz-row>

        </div>
        <div nz-col nzSpan="12" class="ppl-form-item nz-padding-left">

            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="medicaid" class="ppl-form-label">
                    {{getAttributes('medicaid').label}}
                </nz-form-label>
                <nz-form-label [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    {{selectedConsumer.medicaid}}
                </nz-form-label>
            </nz-row>


        </div>
        <div nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="consumerPPLId" class="ppl-form-label">
                    {{getAttributes('consumerPPLId').label}}
                </nz-form-label>
                <nz-form-label [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    {{selectedConsumer.consumerPPLId}}
                </nz-form-label>
            </nz-row>
        </div>
    </div>
    }

    @if(!isNewAuthSubmitted && (isConsumerSelected || mode==='edit')) {
    @if(mode==='add') {
    <div class="row pb-2 mt-4" style="width: 100%;">
        <h5>Auth Details:</h5>
    </div>
    }
    <div pplFocusTrap class="row" style="width: 100%; margin-left: 0">
        @if(!isNewAuthSubmitted) {
        @if (mode==='edit') {
        @if(isAttrAvailable('pplAuth')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="pplAuth"
                    class="ppl-form-label">{{getAttributes('pplAuth').label}}
                    @if(getAttributes('pplAuth').mandatory === 'Y'){
                    <span>*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('pplAuth')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <input nz-input formControlName="pplAuth" id="pplAuth"
                            placeholder="{{getAttributes('pplAuth').placeholder}}"
                            [ngClass]="{'error': validationErrors['pplAuth'] }" />
                    </div>
                    @if (validationErrors['pplAuth']) {
                    <span class="pl-1 error-message">{{validationErrors['pplAuth']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }
        }
        @if(isAttrAvailable('clientAuth')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="clientAuth"
                    class="ppl-form-label">{{getAttributes('clientAuth').label}}
                    @if(getAttributes('clientAuth').mandatory === 'Y'){
                    <span>*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('clientAuth')?.tooltip || ''"
                        nzTooltipPlacement="topRight">

                        <div style="display: flex; gap: 8px; align-items: center;">
                            <ppl-dropdown-select formControlName="clientAuth" id="clientAuth" [options]="spendingPlans"
                                [showClearButton]="false" [optionLabel]="'clientAuth'" [optionValue]="'clientAuth'"
                                [ngClass]="{'error': validationErrors['clientAuth'] }"
                                placeholder="{{getAttributes('clientAuth').placeholder}}" style="flex: 1 1 90%;">
                            </ppl-dropdown-select>

                            @if(mode !== 'edit' || (canEditSpendingPlan && !disableForm)) {
                            <ppl-button label="Add" icon="fa fa-plus" [customClass]="'primary-button'"
                                [iconPosition]="'left'" (click)="openAddSpendingPlanPopup()" [styleString]="'flex: 0 0 10%;'">
                            </ppl-button>
                            }
                        </div>
                    </div>

                    @if (validationErrors['clientAuth']) {
                    <span class="pl-1 error-message">{{validationErrors['clientAuth']}}</span>
                    }
                </nz-form-control>

            </nz-row>
        </nz-form-item>
        }
        @if(isAttrAvailable('serviceAdminLkp')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="serviceAdminLkp"
                    class="ppl-form-label">{{getAttributes('serviceAdminLkp').label}}
                    @if(getAttributes('serviceAdminLkp').mandatory === 'Y'){
                    <span>*</span>
                    }
                </nz-form-label>

                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('serviceAdminLkp')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <div [ngClass]="{'error': validationErrors['serviceAdminLkp'] }">
                            <ppl-dropdown-select formControlName="serviceAdminLkp" id="serviceAdminLkp"
                                [options]="svcAdminList" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
                                [placeholder]="'Select Service Administration'"></ppl-dropdown-select>
                        </div>
                    </div>
                    @if (validationErrors['serviceAdminLkp']) {
                    <span class="pl-1 error-message">{{validationErrors['serviceAdminLkp']}}</span>
                    }
                </nz-form-control>

            </nz-row>
        </nz-form-item>
        }
        @if(isAttrAvailable('orgName')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="orgName"
                    class="ppl-form-label">{{getAttributes('orgName').label}}
                    @if(getAttributes('orgName').mandatory === 'Y'){
                    <span>*</span>
                    }
                </nz-form-label>

                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('orgName')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <div [ngClass]="{'error': validationErrors['orgName'] }">
                            <ppl-dropdown-select formControlName="orgName" id="orgName" [options]="mcoEntries"
                                [optionLabel]="'orgName'" [optionValue]="'orgId'"
                                [placeholder]="'Select Regional Center'"
                                (selectionChange)="onOrgChange($event)"></ppl-dropdown-select>
                        </div>
                    </div>
                    @if (validationErrors['orgName']) {
                    <span class="pl-1 error-message">{{validationErrors['orgName']}}</span>
                    }
                </nz-form-control>

            </nz-row>
        </nz-form-item>
        }
        @if(isAttrAvailable('serviceCoordinator')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="serviceCoordinator"
                    class="ppl-form-label">{{getAttributes('serviceCoordinator').label}}
                    @if(getAttributes('serviceCoordinator').mandatory === 'Y'){
                    <span>*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('serviceCoordinator')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <input nz-input formControlName="serviceCoordinator" id="serviceCoordinator"
                            placeholder="{{getAttributes('serviceCoordinator').tooltip}}"
                            [ngClass]="{'error': validationErrors['serviceCoordinator'] }" />
                    </div>
                    @if (validationErrors['serviceCoordinator']) {
                    <span class="pl-1 error-message">{{validationErrors['serviceCoordinator']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }

        @if(isAttrAvailable('serviceCode')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="serviceCode"
                    class="ppl-form-label">{{getAttributes('serviceCode').label}}
                    @if(getAttributes('serviceCode').mandatory === 'Y'){
                    <span>*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('serviceCode')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <div [ngClass]="{'error': validationErrors['serviceCode'] }">
                            <ppl-dropdown-select formControlName="serviceCode" id="serviceCode"
                                [options]="serviceCodesList" [optionLabel]="'description'"
                                [optionValue]="'servicecodeDetailId'" [placeholder]="'Select Service code'"
                                (selectionChange)="serviceCodeChanged($event)"></ppl-dropdown-select>
                        </div>
                    </div>
                    @if (validationErrors['serviceCode']) {
                    <span class="pl-1 error-message">{{validationErrors['serviceCode']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }
        @if(isAttrAvailable('serviceDescription')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="serviceDescription"
                    class="ppl-form-label">{{getAttributes('serviceDescription').label}}
                    @if(getAttributes('serviceDescription').mandatory === 'Y'){
                    <span>*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('serviceDescription')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <input nz-input formControlName="serviceDescription" id="serviceDescription"
                            placeholder="{{getAttributes('serviceDescription').tooltip}}"
                            [ngClass]="{'error': validationErrors['serviceDescription'] }" />
                    </div>
                    @if (validationErrors['serviceDescription']) {
                    <span class="pl-1 error-message">{{validationErrors['serviceDescription']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }
        <!-- </div> -->
        <!-- <div class="row" style="width: 100%; margin-left: 0">
    </div> -->
        <!-- <div class="row" style="width: 100%; margin-left: 0"> -->
        @if(isAttrAvailable('source')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="source"
                    class="ppl-form-label">{{getAttributes('source').label}}
                    @if(getAttributes('source').mandatory === 'Y'){
                    <span>*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('source')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <div [ngClass]="{'error': validationErrors['source'] }">
                            <ppl-dropdown-select formControlName="source" id="source" [options]="authSourceList"
                                [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
                                [placeholder]="'Select Source'"></ppl-dropdown-select>
                        </div>
                    </div>
                    @if (validationErrors['source']) {
                    <span class="pl-1 error-message">{{validationErrors['source']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }
        @if(isAttrAvailable('authFrequencyLkp')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="authFrequencyLkp"
                    class="ppl-form-label">{{getAttributes('authFrequencyLkp').label}}
                    @if(getAttributes('authFrequencyLkp').mandatory === 'Y'){
                    <span>*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('authFrequencyLkp')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <div [ngClass]="{'error': validationErrors['authFrequencyLkp'] }">
                            <ppl-dropdown-select formControlName="authFrequencyLkp" id="authFrequencyLkp"
                                [options]="authFrequencyTypeList" [optionLabel]="'lkpValueName'"
                                [optionValue]="'lkpValueName'"
                                placeholder="{{getAttributes('authFrequencyLkp').placeholder}}"
                                (selectionChange)="authFreqChanged()"></ppl-dropdown-select>
                        </div>
                    </div>
                    @if (validationErrors['authFrequencyLkp']) {
                    <span class="pl-1 error-message">{{validationErrors['authFrequencyLkp']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }

        @if(isAttrAvailable('startDate')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="startDate"
                    class="ppl-form-label">{{getAttributes('startDate').label}}
                    @if(getAttributes('startDate').mandatory === 'Y'){
                    <span>*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('startDate')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <!-- <nz-date-picker formControlName="startDate" id="startDate" [nzFormat]="'MM/dd/yyyy'"
                            [nzPlaceHolder]="getAttributes('startDate').placeholder"
                            [nzDisabledDate]="disabledStartDate"
                            [ngClass]="{'error': validationErrors['startDate'] }"></nz-date-picker> -->
                        <ppl-date-picker formControlName="startDate" id="startDate" [showIcon]="true"
                            [placeholder]="getAttributes('startDate').placeholder" dateFormat="mm/dd/yy"
                            [readonlyInput]="false" [monthNavigator]="true" [yearNavigator]="true"
                            [yearRange]="'1900:2050'" [disableControl]="disableDate" [iconDisplay]="'input'"
                            inputId="icondisplay" [panelStyleClass]="'custom-calendar-panel'" [maxDate]="minStartDate"
                            [styleClass]="validationErrors['startDate'] ? 'error' : ''"></ppl-date-picker>
                    </div>
                    @if (validationErrors['startDate']) {
                    <span class="pl-1 error-message">{{validationErrors['startDate']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }
        @if(isAttrAvailable('endDate')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="endDate"
                    class="ppl-form-label">{{getAttributes('endDate').label}}
                    @if(getAttributes('endDate').mandatory === 'Y'){
                    <span>*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('endDate')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <!-- <nz-date-picker formControlName="endDate" id="endDate" [nzFormat]="'MM/dd/yyyy'"
                            [nzPlaceHolder]="getAttributes('endDate').placeholder" [nzDisabledDate]="disabledEndDate"
                            [ngClass]="{'error': validationErrors['endDate'] }"></nz-date-picker> -->
                        <ppl-date-picker formControlName="endDate" id="endDate" [showIcon]="true"
                            [placeholder]="getAttributes('endDate').placeholder" dateFormat="mm/dd/yy"
                            [readonlyInput]="false" [monthNavigator]="true" [yearNavigator]="true"
                            [yearRange]="'1900:2050'" [disableControl]="disableDate" [iconDisplay]="'input'"
                            inputId="icondisplay" [panelStyleClass]="'custom-calendar-panel'" [minDate]="maxEndDate"
                            [styleClass]="validationErrors['endDate'] ? 'error' : ''"></ppl-date-picker>
                    </div>
                    @if (validationErrors['endDate']) {
                    <span class="pl-1 error-message">{{validationErrors['endDate']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }

        @if(isAttrAvailable('categoryLkp')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="categoryLkp"
                    class="ppl-form-label">{{getAttributes('categoryLkp').label}}
                    @if(getAttributes('categoryLkp').mandatory === 'Y'){
                    <span>*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('categoryLkp')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <div [ngClass]="{'error': validationErrors['categoryLkp'] }">
                            <ppl-dropdown-select formControlName="categoryLkp" id="categoryLkp" [options]="authTypeList"
                                [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
                                placeholder="{{getAttributes('categoryLkp').placeholder}}">
                            </ppl-dropdown-select>
                        </div>
                    </div>
                    @if (validationErrors['categoryLkp']) {
                    <span class="pl-1 error-message">{{validationErrors['categoryLkp']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }

        @if(isAttrAvailable('units')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="units"
                    class="ppl-form-label">{{getAttributes('units').label}}
                    @if(getAttributes('units').mandatory === 'Y'){
                    <span>*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div>
                        <input nz-input realNumberOnly formControlName="units" id="units"
                            placeholder="{{getAttributes('units').placeholder}}"
                            [ngClass]="{'error': validationErrors['units'] }" />
                    </div>
                    @if (validationErrors['units']) {
                    <span class="pl-1 error-message">{{validationErrors['units']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }
        @if(isAttrAvailable('totalAuthUnits')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="totalAuthUnits"
                    class="ppl-form-label">{{getAttributes('totalAuthUnits').label}}
                    @if(getAttributes('totalAuthUnits').mandatory === 'Y'){
                    <span>*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div>
                        <input nz-input realNumberOnly formControlName="totalAuthUnits" id="totalAuthUnits"
                            placeholder="{{getAttributes('totalAuthUnits').placeholder}}"
                            [ngClass]="{'error': validationErrors['totalAuthUnits'] }" />
                    </div>
                    @if (validationErrors['totalAuthUnits']) {
                    <span class="pl-1 error-message">{{validationErrors['totalAuthUnits']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }
        @if(isAttrAvailable('unittypeLkp')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="unittypeLkp"
                    class="ppl-form-label">{{getAttributes('unittypeLkp').label}}
                    @if(getAttributes('unittypeLkp').mandatory === 'Y'){
                    <span>*</span>
                    }
                </nz-form-label>

                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('unittypeLkp')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <input nz-input formControlName="unittypeLkp" id="unittypeLkp" placeholder="Unit Type"
                            [ngClass]="{'error': validationErrors['unittypeLkp'] }" />
                    </div>
                    @if (validationErrors['unittypeLkp']) {
                    <span class="pl-1 error-message">{{validationErrors['unittypeLkp']}}</span>
                    }
                </nz-form-control>

            </nz-row>
        </nz-form-item>
        }

        @if(isAttrAvailable('dollars')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="dollars"
                    class="ppl-form-label">{{getAttributes('dollars').label}}
                    @if(getAttributes('dollars').mandatory === 'Y'){
                    <span>*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('dollars')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <input nz-input realNumberOnly formControlName="dollars" id="dollars"
                            placeholder="{{getAttributes('dollars').tooltip}}"
                            [ngClass]="{'error': validationErrors['dollars'] }" />
                    </div>
                    @if (validationErrors['dollars']) {
                    <span class="pl-1 error-message">{{validationErrors['dollars']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }

        @if(isAttrAvailable('comments')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="comments"
                    class="ppl-form-label">{{getAttributes('comments').label}}
                    @if(getAttributes('comments').mandatory === 'Y'){
                    <span>*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control" nz-tooltip
                    nzTooltipTitle="{{getAttributes('comments').tooltip}}" nzTooltipPlacement="topRight">
                    <textarea rows="4" cols="40" nz-input formControlName="comments" id="comments"
                        class="ppl-form-control" placeholder="{{getAttributes('comments').placeholder}}"
                        [ngClass]="{'error': validationErrors['comments'] }"></textarea>
                    @if (validationErrors['comments']) {
                    <span class="pl-1 error-message">{{validationErrors['comments']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }

        @if(isAttrAvailable('carryoverUnits')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="carryoverUnits"
                    class="ppl-form-label">{{getAttributes('carryoverUnits').label}}
                    @if(getAttributes('carryoverUnits').mandatory === 'Y'){
                    <span>*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('carryoverUnits')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <div [ngClass]="{'error': validationErrors['carryoverUnits'] }">
                            <ppl-dropdown-select formControlName="carryoverUnits" id="carryoverUnits"
                                [options]="radioOptions" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
                                [placeholder]="' '"></ppl-dropdown-select>
                        </div>
                    </div>
                    @if (validationErrors['carryoverUnits']) {
                    <span class="pl-1 error-message">{{validationErrors['carryoverUnits']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }
        @if(mode === 'edit'){
        @if(isAttrAvailable('sourceDetail')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="sourceDetail"
                    class="ppl-form-label">{{getAttributes('sourceDetail').label}}
                    @if(getAttributes('sourceDetail').mandatory === 'Y'){
                    <span>*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('sourceDetail')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <input nz-input formControlName="sourceDetail" id="sourceDetail"
                            placeholder="{{getAttributes('sourceDetail').placeholder}}"
                            [ngClass]="{'error': validationErrors['sourceDetail'] }" />
                    </div>
                    @if (validationErrors['sourceDetail']) {
                    <span class="pl-1 error-message">{{validationErrors['sourceDetail']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }
        @if(isAttrAvailable('statusLkp')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="statusLkp"
                    class="ppl-form-label">{{getAttributes('statusLkp').label}}
                    @if(getAttributes('statusLkp').mandatory === 'Y'){
                    <span>*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('statusLkp')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <input nz-input formControlName="statusLkp" id="statusLkp"
                            placeholder="{{getAttributes('statusLkp').placeholder}}"
                            [ngClass]="{'error': validationErrors['statusLkp'] }" />
                    </div>
                    @if (validationErrors['statusLkp']) {
                    <span class="pl-1 error-message">{{validationErrors['statusLkp']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }
        @if(isAttrAvailable('decisionComments')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="decisionComments"
                    class="ppl-form-label">{{getAttributes('decisionComments').label}}
                    @if(getAttributes('decisionComments').mandatory === 'Y'){
                    <span>*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('decisionComments')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <input nz-input formControlName="decisionComments" id="decisionComments"
                            placeholder="{{getAttributes('decisionComments').placeholder}}"
                            [ngClass]="{'error': validationErrors['decisionComments'] }" />
                    </div>
                    @if (validationErrors['decisionComments']) {
                    <span class="pl-1 error-message">{{validationErrors['decisionComments']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }
        @if(isAttrAvailable('decisionBy')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="decisionBy"
                    class="ppl-form-label">{{getAttributes('decisionBy').label}}
                    @if(getAttributes('decisionBy').mandatory === 'Y'){
                    <span>*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('decisionBy')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <input nz-input formControlName="decisionBy" id="decisionBy"
                            placeholder="{{getAttributes('decisionBy').placeholder}}"
                            [ngClass]="{'error': validationErrors['decisionBy'] }" />
                    </div>
                    @if (validationErrors['decisionBy']) {
                    <span class="pl-1 error-message">{{validationErrors['decisionBy']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }
        }
        }

        @if(isNew && isConsumerSelected && !isNewAuthSubmitted) {
        <div class="custom-row">
            @if(!authAdded){
            <ppl-button label="Save and Next" icon="fa fa-check-circle" [customClass]="'alt-button'"
                [iconPosition]="'left'" (click)="onAdd()"></ppl-button>
            }
        </div>
        }
    </div>
    }


</form>

@if(isNew){
@if (!isConsumerSelected && mode==='add') {
<div class="custom-row">
    <ppl-button label="Search" icon="fa fa-check-circle" [customClass]="'primary-button'" [iconPosition]="'right'"
        (click)="onConsumerSearch()"></ppl-button>
</div>
@if(showSearchError) {
<p class="pl-1 error-message">Please enter atleast one search criteria.</p>
}
}
}

@if (showConsumersList) {
<div class="row" style="width: 100%">
    <h4 class="step-header">Step 2: Select Participant</h4>
</div>
<div class="table-style">
    <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="true" [data]="gridData"
        [disableSelection]="true" [cols]="cols" [gridTitle]="false" [pagination]="true" [recordsPerPage]="10"
        (gridAction)="action($event)" [actionButtons]="actionButtons">
    </ppl-list-table>
</div>
}

@if(isNew){
@if (mode==='edit' && !disableForm) {
<div class="custom-row">
    @if(mode==="edit" ){
    <ppl-button label="Cancel" icon="fa fa-ban" [customClass]="'alt-button'" [iconPosition]="'left'"
        (click)="onCancelUpdate()"></ppl-button>
    <ppl-button label="Save" icon="fa fa-floppy-o" [customClass]="'alt-button'" [iconPosition]="'left'"
        (click)="updateAuthDetails()"></ppl-button>
    }
</div>
}

@if (from === 'add' && isNewAuthSubmitted && !isProviderAuthAllocated) {
<div class="custom-back-button-row" style="margin-bottom: 12px;">
    <ppl-button label="Back" icon="fa fa-chevron-left" [customClass]="'primary-button'" [iconPosition]="'left'"
        (click)="onMoveBackToAddAuth(false)"></ppl-button>
    <ppl-button label="Add New Auth for Same Participant" icon="fa fa-chevron-left" [styleString]="'margin-left: 8px;'"
        [customClass]="'primary-button'" [iconPosition]="'left'" (click)="onMoveBackToAddAuth(true)"></ppl-button>
</div>
<div class="row" style="width: 100%">
    <h4 class="step-header">Step 4: Provider Auth Allocation</h4>
</div>
}

@if((from === 'add' && isNewAuthSubmitted && !isProviderAuthAllocated)){
@if(from === 'details') {
<div class="row" style="width: 100%">
    <h4 class="step-header m-2">Auth Allocation by Provider</h4>
</div>
}
<ppl-auth-allocation-list [mode]="disableForm" [authId]="savedAuthId" [authData]="consumerAuthData"
    [consumer]="selectedConsumer"></ppl-auth-allocation-list>
}

@if (from === 'add' && isNewAuthSubmitted && !isProviderAuthAllocated) {
<div class="custom-row">
    <ppl-button label="Next" icon="fa fa-check-circle" class="primary-button" [iconPosition]="'left'"
        (click)="onNextClick()"></ppl-button>
</div>
}

@if (from === 'add' && isNewAuthSubmitted && isProviderAuthAllocated) {
<div class="custom-back-button-row" style="margin-bottom: 12px;">
    <ppl-button label="Back" icon="fa fa-chevron-left" [customClass]="'primary-button'" [iconPosition]="'left'"
        (click)="onMoveBackToAuthAllocation()"></ppl-button>
    <ppl-button label="Add New Auth for Same Participant" icon="fa fa-chevron-left" [styleString]="'margin-left: 8px;'"
        [customClass]="'primary-button'" [iconPosition]="'left'" (click)="onMoveBackToAddAuth(true)"></ppl-button>
</div>
<div class="row pb-3 mt-8" style="width: 100%">
    <h4 class="step-header">Step 5: Upload Documents</h4>
</div>
<ppl-file-upload [filedInfo]="filedInfo" [authId]="savedAuthId" [sectionData]="" [entry]="'auth'"
    (filesUpdated)="filesUpdated()" [readonly]="false"></ppl-file-upload>
<div class="custom-row">
    <ppl-button label="Finish" icon="fa fa-check-circle" [customClass]="'alt-button'" [iconPosition]="'left'"
        (click)="navigateToDetailsPage()"></ppl-button>
</div>
}

@if (showAddedAuths) {
<div class="row" style="width: 100%">
    <h5>Authorizations Added</h5>
</div>
<div class="table-style">
    <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="false" [data]="authsInSession"
        [disableSelection]="true" [cols]="authCols" [gridTitle]="false" [pagination]="true" [loadPage]="false"
        (gridAction)="action($event)" [actionsToBeHidden]="actionsToBeHidden">
    </ppl-list-table>
</div>
}
}

<div class="filter-panel">
    <ng-template #diagnosisListDialog let-cancel="cancel">
        <ppl-search-add-diagnosis-code (diagnosisCodeSelected)="diagnosisCodeSelected($event)"
            [control]="control"></ppl-search-add-diagnosis-code>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #addAuthSpendingPlan let-cancel="cancel">
        <div class="row" style="width: 100%; margin-left: 0">
            <div class="col">
                <input type="text" placeholder="Enter Spending Plan" class="form-control" id="spendingPlan"
                    name="spendingPlan" [(ngModel)]="spendingPlan" maxlength="25" />
            </div>
            <div class="col-auto">
                <ppl-button label="Add to Spending Plan" icon="fa fa-check-circle" [customClass]="'alt-button'"
                    [iconPosition]="'left'" (click)="onCreateSpendingPlan()"></ppl-button>
            </div>
        </div>
    </ng-template>
</div>
<div class="filter-panel">
  <ng-template #approvedAuthconfirmationDialog let-cancel="cancel">
    <p> By submitting this change, you are confirming this has also been approved by the program's external funding representative.</p>
  </ng-template>
</div>